module.exports = __webpack_public_path__ + "img/5.88d9908f.png";